import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CampaignListComponent } from './components/campaign-list/campaign-list.component';
import { AppCommonModule } from 'src/app/common/common.module';
import { CampaignAdapter } from '../../../../adapters/campaign-adapter';
import { ChartsModule } from 'ng2-charts';
import { CampaignRunningStatusComponent } from './components/campaign-running-status/campaign-running-status.component';
import { CampaignVerticalStepperContentComponent } from './components/campaign-vertical-stepper-content/campaign-vertical-stepper-content.component';
import { TimezonePipe } from 'src/app/common/pipes/timezone.pipe';

const components = [
  CampaignListComponent,
  CampaignRunningStatusComponent,
  CampaignVerticalStepperContentComponent
];

@NgModule({
  declarations: components,
  providers: [CampaignAdapter, TimezonePipe],
  imports: [
    CommonModule,
    AppCommonModule,
    ChartsModule
  ],
  exports: components
})
export class CampaignListModule {
}
